import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { nudgeApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${nudgeApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
